<template>
  <div class="mini-received-place-card">
    <div class="sender-profile-container">
      <img class="sender-profile" :src="senderProfilePath !== '' ? senderProfilePath : util.getImagePath('pin_blue@2x.png')" :srcset="senderProfilePath !== '' ? `${senderProfilePath} 2x` : util.getImageSet('pin_blue')">
      <img class="sent-icon" :src="util.getImagePath('out_gray@2x.png')" :srcset="util.getImageSet('out_gray')" v-if="isSent">
      <img class="receive-icon" :src="util.getImagePath('in_orange@2x.png')" :srcset="util.getImageSet('in_orange')" v-if="!isSent">
    </div>
    <div class="detail">
      <div class="sender-display-name">{{ senderDisplayName }}</div>
      <div class="name">{{ $i18n.locale === 'th' ? nameTh : nameEn }}</div>
      <PromptPaiSnippetButton :id="code" />
      <!-- <div class="code">{{ displayCode }}</div> -->
      <!-- <iframe :src="`https://promptpai.com/ws/promptpai-link?pp_id=${code}&code_type=id&size=normal&button_style=button&theme=light&locale=th`" width="104" height="22" style="border: none; overflow: hidden;" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"/> -->
    </div>
    <div class="right-container">
      <div class="date" v-html="displayDate"></div>
      <div class="time" v-html="displayTime"></div>
    </div>
  </div>
</template>

<script>
import PromptPaiSnippetButton from '@/components/PromptPaiSnippetButton.vue'

export default {
  name: 'MiniReceivedPlaceCard',
  components: {
    PromptPaiSnippetButton
  },
  props: {
    isSent: {
      type: Boolean,
      default: false
    },
    senderProfilePath: {
      type: String,
      default: ''
    },
    senderDisplayName: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    nameTh: {
      type: String,
      default: ''
    },
    nameEn: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    timestamp: {
      type: String,
      default: ''
    }
  },
  computed: {
    displayCode () {
      var self = this
      if (self.code.length === 8) {
        return self.code.substring(0, 4) + ' ' + self.code.substring(4, 8)
      } else {
        return ''
      }
    },
    displayDate () {
      var self = this
      var month = [
        {
          th: 'ม.ค.',
          en: 'Jan'
        },
        {
          th: 'ก.พ.',
          en: 'Feb'
        },
        {
          th: 'มี.ค.',
          en: 'Mar'
        },
        {
          th: 'เม.ย.',
          en: 'Apr'
        },
        {
          th: 'พ.ค.',
          en: 'May'
        },
        {
          th: 'มิ.ย.',
          en: 'Jun'
        },
        {
          th: 'ก.ค.',
          en: 'Jul'
        },
        {
          th: 'ส.ค.',
          en: 'Aug'
        },
        {
          th: 'ก.ย.',
          en: 'Sep'
        },
        {
          th: 'ต.ค.',
          en: 'Oct'
        },
        {
          th: 'พ.ย.',
          en: 'Nov'
        },
        {
          th: 'ธ.ค.',
          en: 'Dec'
        }
      ]
      var date = new Date(Number(self.timestamp) * 1000)
      return `${date.getDate()} ${month[date.getMonth()][self.$root.$i18n.locale]} ${`${(Number(date.getFullYear()) + (self.$root.$i18n.locale === 'th' ? 543 : 0))}`.substr(-2)}`
    },
    displayTime () {
      var self = this
      var date = new Date(Number(self.timestamp) * 1000)
      return `${date.getHours()}:${`0${date.getMinutes()}`.substr(-2)}`
    }
  },
  methods: {
  }
}
</script>

<style scoped>
  .mini-received-place-card {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }

  .sender-profile-container {
    width: 32px;
    height: 32px;
    margin: 6px 14px auto 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  img.sender-profile {
    width: 32px;
    height: 100%;
    max-height: 32px;
    object-fit: cover;
  }

  .sent-icon,
  .receive-icon {
    position: absolute;
    width: 32px;
    height: 32px;
    top: 16px;
    left: 12px;
  }

  .detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: calc(100% - 60px - 80px);
  }

  .detail > .sender-display-name {
    color: rgb(74, 74, 74);
    font-weight: bold;
    line-height: 1.75;
    text-align: left;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .detail > .name {
    font-size: 14px;
    color: rgb(120, 120, 120);
    line-height: 1.5;
    text-align: left;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-bottom: 4px;
    text-indent: 2px;
  }

  .detail > .code {
    font-size: 16px;
    color: rgb(34, 84, 156);
    line-height: 1;
    padding: 2px 11px 0px 0px;
    margin: 2px auto 0px 0px;
    border: 1px solid rgb(34, 84, 156);
    border-radius: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .right-container {
    width: 80px;
    margin: 0px 14px 0px 7px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    padding: 6px 0px 0px 0px;
  }

  .date {
    font-size: 14px;
    text-align: right;
  }

  .time {
    font-size: 14px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/MiniReceivedPlaceCard.vue